// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vue-notification-group[data-v-323b25f5] {
  z-index: 999999;
}
@media (max-width: 768px) {
.vue-notification-group[data-v-323b25f5] {
    width: 100%;
}
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/App.vue","webpack://./App.vue"],"names":[],"mappings":"AACC;EACI,eAAA;ACAL;ADEC;AACE;IACE,WAAA;ACAH;AACF","sourcesContent":["\n .vue-notification-group {\n     z-index: 999999;\n }\n @media (max-width: 768px) {\n   .vue-notification-group {\n     width: 100%;\n   }\n }\n",".vue-notification-group {\n  z-index: 999999;\n}\n@media (max-width: 768px) {\n  .vue-notification-group {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
